/**
 * @author TankNee 2020-08-17
 * simple audio recorder
 */

import React from "react";
import PropTypes from "prop-types";
import Recorder from "js-audio-recorder";
import { Button } from "reactstrap";
import UIDs from "../../UIDs";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as FAIcons from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";
const uid = UIDs.components.ui.audiorecorder;

import Mp3Recorder from 'recorder-core';
import 'recorder-core/src/engine/mp3';
import 'recorder-core/src/engine/mp3-engine';

let recorder = new Recorder({
    sampleBits: 16, // 采样位数，支持 8 或 16，默认是16
    sampleRate: 16000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
    numChannels: 1, // 声道，支持 1 或 2， 默认是1
    // compiling: false,(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
});
const state = {
    START_UP: 1,
    RECORDING: 2,
    PAUSED: 3,
    FINISH: 4,
    PLAYING: 5,
};
class AudioRecorder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentState: state.START_UP,
        };

        this.localVars = {
        };

        if (props.encodeFormat === 'mp3') {
            this.localVars.enableMp3Encoder = true;
        } else {
            this.localVars.enableMp3Encoder = false;
        }
    }

    componentDidMount() {
        recorder.onplayend = () => {
            this.setState({
                currentState: state.FINISH,
            });
        };
    }

    componentWillUnmount() {
        if (this.localVars.mp3Recorder) {
            this.localVars.mp3Recorder.close();
            this.localVars.mp3Recorder = null;
        }
        recorder.stop();
    }

    render() {
        return (
            <div className="row align-items-center" style={{ flexWrap: "nowrap" }}>
                {this.state.currentState === state.START_UP ? (
                    <Button onClick={this._handleRecordStart.bind(this)} style={{ display: "flex" }}>
                        <FontAwesomeIcon icon={FAIcons.faMicrophone} style={{ width: "24px", height: "24px", margin: "0 auto" }} color={"#B5D685"} title={this.props.t("start")} />
                        <div style={{ alignSelf: "center" }}>{this.props.startTip}</div>
                    </Button>
                ) : null}
                {this.props.enablePause && this.state.currentState === state.RECORDING ? (
                    <Button onClick={this._handleRecordPause.bind(this)} style={{ display: "flex" }}>
                        <FontAwesomeIcon icon={FAIcons.faPause} style={{ width: "24px", height: "24px", margin: "0 auto" }} color={"#F87550"} title={this.props.t("pause")} />
                        <div style={{ alignSelf: "center" }}>{this.props.pauseTip}</div>
                    </Button>
                ) : null}
                {this.props.enablePause && this.state.currentState === state.PAUSED ? (
                    <Button onClick={this._handleRecordResume.bind(this)} style={{ display: "flex" }}>
                        <FontAwesomeIcon icon={FAIcons.faMicrophoneAlt} style={{ width: "24px", height: "24px", margin: "0 auto" }} color={"#4CA2E2"} title={this.props.t("resume")}/>
                        <div style={{ alignSelf: "center" }}>{this.props.resumeTip}</div>
                    </Button>
                ) : null}
                {this.state.currentState === state.RECORDING || this.state.currentState === state.PAUSED ? (
                    <Button onClick={this._handleStop.bind(this)} style={{ display: "flex" }}>
                        <FontAwesomeIcon icon={FAIcons.faStop} style={{ width: "24px", height: "24px", margin: "0 auto" }} color={"#F87550"} title={this.props.t("stop")} />
                        <div style={{ alignSelf: "center" }}>{this.props.endTip}</div>
                    </Button>
                ) : null}
                {/* {this.state.currentState === state.PAUSED && (
                    <Button onClick={this._handleRecordResume.bind(this)}>
                        <FontAwesomeIcon icon={FAIcons.faMicrophoneAlt} style={{ width: "24px", height: "24px" }} color={"#4CA2E2"} title={this.props.t("resume")}/>
                    </Button>
                )}
                {this.state.currentState === state.FINISH && (
                    <Button onClick={this._handleRecordPlay.bind(this)}>
                        <FontAwesomeIcon icon={FAIcons.faPlay} style={{ width: "24px", height: "24px" }} color={"#55BFA0"} title={this.props.t("play")}/>
                    </Button>
                )}
                {[state.RECORDING, state.PAUSED].includes(this.state.currentState) && (
                    <Button onClick={this._handleStop.bind(this)}>
                        <FontAwesomeIcon icon={FAIcons.faStop} style={{ width: "24px", height: "24px" }} color={"#F87550"} title={this.props.t("stop")}/>
                    </Button>
                )}
                {this.state.currentState === state.PLAYING && (
                    <Button onClick={this._handleRecordStop.bind(this)}>
                        <FontAwesomeIcon icon={FAIcons.faStop} style={{ width: "24px", height: "24px" }} color={"#F87550"} title={this.props.t("stop")}/>
                    </Button>
                )} */}
            </div>
        );
    }
    _handleRecordStart() {
        if (this.localVars.mp3Recorder) {
            this.localVars.mp3Recorder.close();
            this.localVars.mp3Recorder = null;
        }

        if (this.localVars.enableMp3Encoder) {
            this.localVars.mp3Recorder = Mp3Recorder({
                type: "mp3",
                sampleRate: 16000,
                bitRate: 16,
                onProcess: (buffers, powerLevel, bufferDuration, bufferSampleRate, newBufferIdx, asyncEnd) => {
                    //录音实时回调，大约1秒调用12次本回调，buffers为开始到现在的所有录音pcm数据块(16位小端LE)
                    //可利用extensions/sonic.js插件实时变速变调，此插件计算量巨大，onProcess需要返回true开启异步模式
                    //可实时上传（发送）数据，配合Recorder.SampleData方法，将buffers中的新数据连续的转换成pcm上传，或使用mock方法将新数据连续的转码成其他格式上传，可以参考文档里面的：Demo片段列表 -> 实时转码并上传-通用版；基于本功能可以做到：实时转发数据、实时保存数据、实时语音识别（ASR）等

                    //可实时绘制波形（extensions目录内的waveview.js、wavesurfer.view.js、frequency.histogram.view.js插件功能）
                    //wave&&wave.input(buffers[buffers.length-1],powerLevel,bufferSampleRate);


                    if (this.localVars.eventEmitter) {
                        this.localVars.eventEmitter.emit("onVolumeChange", { type: "onVolumeChange", Volume: powerLevel });
                    }

                    this.localVars.currentVol = powerLevel;
                }
            });
        }

        if (this.localVars.mp3Recorder) {
            this.localVars.mp3Recorder.open(() => {
                this.localVars.mp3Recorder.start();
                this.setState({ currentState: state.RECORDING, });
                this.props.onRecordStart();
            }, (msg, isUserNotAllow) => {
                //用户拒绝未授权或不支持
                //console.log((isUserNotAllow?"UserNotAllow，":"")+"无法录音:"+msg);
                //reject(new Error(`${msg}`));
                this.props.onRecordError(new Error(`${msg}`));
            });
            return;
        }

        recorder
            .start()
            .then(() => {
                recorder.resumeRecord();
                this.setState({ currentState: state.RECORDING, });
                this.props.onRecordStart();
            },(error) => {
                if (error){
                    let newError = {};
                    if (error.name === "NotFoundError" || error.name === "DevicesNotFoundError") {
                        newError = { ...error, message: this.props.t("devicesNotFoundError")};
                    } else if (error.name === "NotReadableError" || error.name === "TrackStartError") {
                        newError = { ...error, message: this.props.t("notReadableError")};
                    } else if (error.name === "OverconstrainedError" || error.name === "ConstraintNotSatisfiedError") {
                        newError = { ...error, message: this.props.t("overconstrainedError")};
                    } else if (error.name === "NotAllowedError" || error.name === "PermissionDeniedError") {
                        newError = { ...error, message: this.props.t("notAllowedError")};
                    } else if (error.name === "TypeError" || error.name === "TypeError") {
                        newError = { ...error, message: this.props.t("typeError")};
                    } else {
                        newError = { ...error, message: this.props.t("somethingWrong")};
                    }
                    this.props.onRecordError(newError);
                }
                recorder.stop();
            })
            .catch(err => {
                console.log(err);
            });
    }
    _handleRecordPause() {
        this.setState(
            {
                currentState: state.PAUSED,
            },
            () => {
                if (this.localVars.mp3Recorder) {
                    this.localVars.mp3Recorder.pause();
                } else {
                    recorder.pause();
                }
            }
        );
    }
    _handleRecordResume() {
        this.setState(
            {
                currentState: state.RECORDING,
            },
            () => {
                if (this.localVars.mp3Recorder) {
                    this.localVars.mp3Recorder.resume();
                } else {
                    recorder.resume();
                }
            }
        );
    }
    _handleRecordPlay() {
        this.setState(
            {
                currentState: state.PLAYING,
            },
            () => {
                recorder.play();
            }
        );
    }

    _handleStop() {
        this.setState(
            {
                currentState: state.FINISH,
            },
            () => {
                if (this.localVars.mp3Recorder) {
                    this.localVars.mp3Recorder.stop((blob, duration) => {
                        //简单利用URL生成本地文件地址，注意不用了时需要revokeObjectURL，否则霸占内存
                        //此地址只能本地使用，比如赋值给audio.src进行播放，赋值给a.href然后a.click()进行下载（a需提供download="xxx.mp3"属性）
                        //var localUrl=(window.URL||webkitURL).createObjectURL(blob);
                        //console.log(blob,localUrl,"时长:"+duration+"ms");

                        this.localVars.mp3Recorder.close();//释放录音资源，当然可以不释放，后面可以连续调用start；但不释放时系统或浏览器会一直提示在录音，最佳操作是录完就close掉
                        this.localVars.mp3Recorder = null;

                        this.props.onRecordEnd(blob);
                    }, (msg) => {
                        console.warn("录音失败:" + msg);
                        this.localVars.mp3Recorder.close();
                        this.localVars.mp3Recorder = null;
                        this.props.onRecordError(new Error(`${msg}`));
                    });
                } else {
                    recorder.stop();
                    this.props.onRecordEnd(recorder.getWAVBlob());
                }
            }
        );
    }

    _handleRecordStop() {
        this.setState(
            {
                currentState: state.FINISH,
            },
            () => {
                recorder.stopPlay();
            }
        );
    }
}
AudioRecorder.propTypes = {
    enablePause: PropTypes.bool,
    pauseTip: PropTypes.string,
    resumeTip: PropTypes.string,
    startTip: PropTypes.string,
    endTip: PropTypes.string,
    onRecordStart: PropTypes.func,
    onRecordEnd: PropTypes.func,
    onRecordError: PropTypes.func,
};
AudioRecorder.defaultProps = {
    enablePause: false,
    pauseTip: "",
    resumeTip: "",
    startTip: "",
    endTip: "",
    onRecordStart: () => { },
    onRecordEnd: () => { },
    onRecordError: console.error,
};
export default withTranslation(uid, { withRef: true })(AudioRecorder);
